module.exports = __webpack_public_path__ + "static/media/take-away-black.1ae7f343.svg";